import { API_CONFIG } from '@/config/api'

export type EmailDeliverability = {
  readonly deliverable: boolean
  readonly reason: string | null
}

/**
 * Check whether an email address can receive mail (syntax + domain MX), via the
 * public-key `/integrations/validate-email` endpoint. This is advisory: on any
 * error we assume deliverable so we never wrongly warn or block.
 */
export async function checkEmailDeliverability(email: string, signal?: AbortSignal): Promise<EmailDeliverability> {
  try {
    const response = await fetch(`${API_CONFIG.BASE_URL}/integrations/validate-email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-EnGen-Public-Key': import.meta.env.VITE_ENGEN_PUBLIC_KEY ?? '',
      },
      body: JSON.stringify({ email }),
      signal,
    })
    if (!response.ok) {
      return { deliverable: true, reason: null }
    }
    return (await response.json()) as EmailDeliverability
  } catch {
    return { deliverable: true, reason: null }
  }
}
